// extracted by mini-css-extract-plugin
export var deleteModal = "_en-0";